"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemNameMap = void 0;
const item_data_json_1 = __importDefault(require("../data/items/item_data.json"));
const cleanString_1 = require("../util/cleanString");
const Collection_1 = __importDefault(require("./Collection"));
const items = item_data_json_1.default;
exports.itemNameMap = new Map();
const USELESS_ITEMS = [
    617,
    8890,
    6964,
    2513,
    19492,
    11071,
    11068,
    21284,
    24735,
    21913,
    4703,
    4561,
    2425
];
class Items extends Collection_1.default {
    get(item) {
        const id = this.resolveID(item);
        if (typeof id === 'undefined')
            return undefined;
        return super.get(id);
    }
    resolveID(input) {
        if (typeof input === 'number') {
            return input;
        }
        if (typeof input === 'string') {
            const cleanName = cleanString_1.cleanString(input);
            return exports.itemNameMap.get(cleanName);
        }
        return undefined;
    }
}
const itemsExport = new Items();
for (const [id, item] of Object.entries(items)) {
    const numID = parseInt(id);
    if (USELESS_ITEMS.includes(numID))
        continue;
    itemsExport.set(numID, item);
    const cleanName = cleanString_1.cleanString(item.name);
    if (!exports.itemNameMap.has(cleanName))
        exports.itemNameMap.set(cleanName, numID);
}
exports.default = itemsExport;
//# sourceMappingURL=Items.js.map